import React from 'react';
import PropTypes from 'prop-types';
import './financing-details.style.scss';

export const FinancingDetails = ({
  monthlyPayment,
  price,
  promoEndDate,
  promoStartDate,
  promotionTerm,
  tooltipText
}) => {
  return (
    <div className="u--padding financing-details-wrapper">
      <div className="u--padding financing-details__heading">
        <h4>Financing <br className="mobile-break" />Details</h4>
      </div>
      <div className="u--padding">
        <div className="details-box u__bgColor--faded u__text-align--center u--padding">
          <div>
            <img
              src="https://assets.homedepot-static.com/p/static/images/icons/thd-consumer-creditcard.svg"
              role="presentation"
              className="card-image"
              alt=""
            />
          </div>
          <div className="u__bold ">${ monthlyPayment } per month* suggested payments</div>
          <div>
            with { promotionTerm } months financing on this ${ price } purchase.
          </div>
        </div>
        {promoStartDate === null
        && (
          <div className="financing-details__text--small">
            <p className="u__text--primary u__text-align--justify u--paddingTop">
              {tooltipText}
            </p>
            <p className="u__text--primary u__text-align--justify u--paddingTop">
              Interest will be charged to your account from the purchase date if the purchase
              balance (including premiums for optional credit insurance) is not paid in full within
              6 months. No interest if paid in full within 6 months financing on purchases of $299
              or more.
            </p>
            <p className="u__text--primary u__text-align--justify u--paddingTop">
              *With credit approval for qualifying purchases made on The Home Depot or EXPO Design
              Center Consumer Credit Card. APR: 17.99% – 26.99%. Minimum interest charge: $2. See
              card agreement for details including APR applicable to you. Offer valid for consumer
              accounts in good standing; 6 months everyday credit offer is subject to change without
              notice; see store for details. The suggested monthly payment stated is only an
              estimate based on listed purchase amount excluding sales tax, is rounded to the next
              highest dollar amount and does not include additional payments that may be required
              for an existing balance or future purchases. In order to pay your promotional balance
              by the end of the period, you may have to make a payment each month that is higher
              than your required minimum payment.
            </p>
          </div>
        )}
        {promoStartDate !== null
        && (
          <div className="financing-details__text--small">
            <p className="u__text--primary u__text-align--justify u--paddingTop">
              {tooltipText} Interest will be charged to your account from the purchase date if the
              purchase balance (including premiums for optional credit insurance) is not paid in full
              within the promotional period.
              VALID: { promoStartDate } - { promoEndDate }
            </p>
            <p className="u__text--primary u__text-align--justify u--paddingTop">APR: 17.99% - 26.99%.
              Minimum interest charge: $2. See card agreement for details including APR applicable to
              you.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

FinancingDetails.displayName = 'FinancingDetails';

FinancingDetails.propTypes = {
  price: PropTypes.number.isRequired,
  monthlyPayment: PropTypes.number.isRequired,
  promotionTerm: PropTypes.number.isRequired,
  promoStartDate: PropTypes.string,
  promoEndDate: PropTypes.string,
  tooltipText: PropTypes.string
};

FinancingDetails.defaultProps = {
  promoStartDate: null,
  promoEndDate: null,
  tooltipText: '6 MONTHS EVERY DAY FINANCING* ON PURCHASES OF $299 OR MORE'
};
